import { decryptSessionPayload } from '~/services/sessionCrypto'

export default async ({ store, $axios }) => {
  try {
    if (store?.state?.member?.sessionLoaded) return
    // session 값 추출
    const payload = await $axios.$post('member/session', {})
    
    const encrypted =
      payload?.data?.session ||
      payload?.session ||
      (typeof payload?.data === 'string' ? payload.data : null) ||
      (typeof payload === 'string' ? payload : null)
    // 암호화된 session 값이 없으면 비로그인 상태로 처리
    if (!encrypted) {
      await store.dispatch('member/CLEAR_SESSION_INFO')
      await store.dispatch('member/CLEAR_MEMBER_INFO')
      return
    }

    const session = decryptSessionPayload(encrypted)
    // 복호화 실패 또는 id가 없는 경우 유효하지 않은 세션으로 판단
    if (!session || !session.id) {
      await store.dispatch('member/CLEAR_SESSION_INFO')
      await store.dispatch('member/CLEAR_MEMBER_INFO')
      return
    }
    // 세션 정보 저장
    await store.dispatch('member/SET_SESSION_INFO', session)
    // 세션에 있는 id를 기준으로 실제 회원 상세 정보 조회
    await store.dispatch('member/GET_MEMBER_INFO', { id: session.id })
  } catch (e) {
    const errorCode = e?.response?.data?.error
    // 서버에서 INVALID_SESSION이 내려온 경우
    // 정상적인 비로그인/세션 만료 상태 초기화
    if (errorCode === 'INVALID_SESSION') {
      await store.dispatch('member/CLEAR_SESSION_INFO')
      await store.dispatch('member/CLEAR_MEMBER_INFO')
      return
    }

    console.error('[session-init] restore failed', e)
  }
}